<main class="main-dashboard">
    <article class="main-canvas">
      <section class="canvas-container">
        <section class="dashboard-items">
          <div class="canvas-item">
            <div
              class="canvas-header row justify-content-between align-items-center"
            >
              <div class="title col-sm-6">
                <h3>Vendor List</h3>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                  <button
                    type="button"
                    title="Edit"
                    (click)="editOpenModal()"
                    data-bs-toggle="modal"
                    data-bs-target="#vendor"
                  >
                    <span><i class="ri-pencil-line"></i></span>
                  </button>
                </div>
                <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                  <button
                    type="button"
                    title="Delete"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteVendorModal"
                    (click)="deleteOpenModal()"
                  >
                    <span><i class="ri-delete-bin-5-line"></i></span>
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    title="Create"
                    (click)="createOpenModal()"
                    data-bs-toggle="modal"
                    data-bs-target="#vendor"
                    class="btn btn-icon"
                  >
                    <i class="ri-add-line"></i>
                  </button>
                </div>
              </div>
            </div>
            <ag-grid-angular
              style="height: calc(100vh - 120px) !important;" 
              class="ag-theme-material"
              (gridReady)="onGridReady($event)"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              pagination="true"
              [defaultColDef]="defaultColDef"
              [suppressRowClickSelection]="true"
              [rowSelection]="rowSelection"
              (selectionChanged)="onSelectionChanged($event)"
              paginationPageSize="10"
            >
            </ag-grid-angular>
          </div>
        </section>
      </section>
    </article>
  </main>


  <!-- Create new Lead -->
<div class="modal fade" id="vendor" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="vendorForm">
                <div class="modal-header">
                    <h5 class="modal-title">Create Vendor</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="supplierName" type="text" required>
                            <label for="supplierName" class="floating-label">Supplier Name</label>
                            <i class="ri-file-list-line"></i>
                        </div>
                        <mat-error *ngIf="f.supplierName.touched && f.supplierName.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.supplierName.errors.required">Supplier Name is required</mat-error>
                          <mat-error *ngIf="f.supplierName.errors.pattern">Supplier Name can contain alphabets only</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="address" type="text" >
                            <label for="address" class="floating-label">Address</label>
                            <i class="ri-map-pin-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="telephoneNo" type="text" required>
                            <label for="telephoneNo" class="floating-label">Telephone No</label>
                            <i class="ri-phone-line"></i>
                        </div>
                        <mat-error *ngIf="f.telephoneNo.touched && f.telephoneNo.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.telephoneNo.errors.required">Telephone No. is required</mat-error>
                          <mat-error *ngIf="f.telephoneNo.errors.pattern">Telephone No. can contain Numbers only</mat-error>
                          <mat-error *ngIf="f.telephoneNo.errors.maxlength">Can add max 12 digit to Telephone No.</mat-error>
                          <mat-error *ngIf="f.telephoneNo.errors.minlength">Telephone No. must have at least 10 digits</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="contactName" type="text" required>
                            <label for="contactName" class="floating-label">Contact Name</label>
                            <i class="ri-file-list-line"></i>
                        </div>
                        <mat-error *ngIf="f.contactName.touched && f.contactName.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.contactName.errors.required">Contact Name is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="legelEntityStatus" type="text" required>
                            <label for="legelEntityStatus" class="floating-label">Legel Entity Status</label>
                            <i class="ri-file-list-line"></i>
                        </div>
                        <mat-error *ngIf="f.legelEntityStatus.touched && f.legelEntityStatus.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.legelEntityStatus.errors.required">Legal Entity Status is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                      <div class="input-item">
                      <select formControlName="status" required>
                        <option value="Identified">Identified</option>
                        <option value="Nominated">Nominated</option>
                        <option value="Contracted">Contracted</option>
                        <option value="Obsolete">Obsolete</option>
                      </select>
                      <label class="floating-label-special">Status</label>
                      <i class="ri-mouse-fill"></i>
                    
                        <mat-error *ngIf="f.status.touched && f.status.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.status.errors.required">Status is required</mat-error>
                        </mat-error>
                      </div>   
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="itemsSupplied" type="text" required>
                            <label for="itemsSupplied" class="floating-label">Items Supplied</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.itemsSupplied.touched && f.itemsSupplied.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.itemsSupplied.errors.required">Items Supplied is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="remark" type="text" >
                            <label for="remark" class="floating-label">Remark</label>
                            <i class="ri-database-line"></i>
                        </div>
                    </div>
                   
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createVendor()" [disabled]="!vendorForm.valid">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateVendor()" [disabled]="!vendorForm.valid">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

  <!-- Delete an item -->
<div class="modal fade" id="deleteVendorModal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteVendor" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteVendorList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 